import {Component, Input, OnInit} from '@angular/core';
import {BarChartData} from '../../../models/bar-chart-data';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'achoo-bar-chart',
  templateUrl: './achoo-bar-chart.component.html',
  styleUrls: ['./achoo-bar-chart.component.scss']
})
export class AchooBarChartComponent implements OnInit {
  @Input()
  public series: BarChartData[] = [];
  @Input()
  public isLeftSide = true;
  @Input()
  public hideRelativeCalculation = false;
  @Input()
  public showValue = false;
  @Input()
  public showIndex = false;
  @Input()
  public isPercentValue = false;
  @Input()
  public chartTitleClasses = 'default-title';
  @Input()
  public chartBgColor: string;
  @Input()
  public startIndex = 0;

  // user for placeholder
  @Input()
  public placeholderKeywords;
  @Input()
  public isNormalLine = true;
  @Input()
  public maxLine: number;

  @Input() forPayingUser = false;
  @Input() showPlaceholder = false;

  public progressHeight = 13;
  public borderRadius = 13;

  constructor(public userService: UserService) {
  }

  ngOnInit() {
    if (!this.isNormalLine) {
      this.progressHeight = 27;
      this.borderRadius = 27;
    }
    if (this.maxLine) {
      this.series = this.series.slice(0, this.maxLine);
    }
  }

  calculateProgress(value: number): number {
    if (this.isPercentValue) {
      return value;
    }

    if (this.series.length === 0) {
      return 0;
    }
    const totalValue = this.series.map(s => s.value).reduce((a, b) => a + b);
    return Math.round((value / totalValue) * 100);
  }

  get chartColor() {
    return this.chartBgColor ? this.chartBgColor : this.userService.chartColors[6];
  }

  get canShowChart() {
    if (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin) {
      return false;
    }
    return !this.showPlaceholder;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-bar-chart/achoo-bar-chart.component.ts